export const PLUGIN_NAME = 'clipregion';
